import apiClient from 'src/config/api';
import { QuestionType } from 'src/interfaces/entities/question';

import { QuestionParams } from './types';

export const getQuestionsRequest = (params: QuestionParams) =>
  apiClient.get<QuestionType[]>(
    `/course/${params.courseId}/registration-form/${params.regFormId}/question${params.query}`,
  );

export const editQuestionsRequest = (params: QuestionParams) =>
  apiClient.put<QuestionType[]>(
    `/course/${params.courseId}/registration-form/${params.regFormId}/question/view/${params.viewId}`,
    params.data,
  );
